import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from "react";
import QuestionComponent from "Root/quiz/elements/TextAreaQuestionElement/question";
const RDQuestion = (props) => {
    const handleQuestion = (e) => {
        props.setValue([e]);
    };
    return _jsx(QuestionComponent, { setValue: handleQuestion, value: props.value.length ? props.value[0] : "" });
};
export default memo(RDQuestion);
